(function () {

    angular.module('app.shared', []);

}());
